import { Component, OnInit } from '@angular/core';
import { CMS } from 'src/app/shared/cms';

@Component({
    selector: 'app-footer',
    templateUrl: './footer.component.html',
    styleUrls: ['./footer.component.scss']
,  standalone: false
})
export class FooterComponent implements OnInit {
    cms = new CMS();

    ngOnInit() {
        // This blank function is mandatory
    }
    linkList: [
        {
            link: "/",
            text: 'Health Slice',
        },
        {
            link: "/",
            text: 'Privacy',
        },
        {
            link: "/",
            text: 'Terms & Conditions',
        }
    ];
    copyrightYear: number =  (new Date()).getFullYear();;
    brandName: string = this.cms.brandName;

}
